import React, { useState } from "react";
import {
    AlertTriangleIcon,
    CheckCheckIcon,
} from "lucide-react";
import SwitchIcon from "src/assets/images/switch.svg";
import DotLoader from "src/components/reusable/dot-loader";

interface Finding {
    type: "success" | "warning";
    text: string;
}

interface ChecklistResponse {
    title: string;
    summary: string;
    findings: Finding[];
}

interface Props {
    json_response: ChecklistResponse | null;
    loading?: boolean;
}

const QuickHealth: React.FC<Props> = ({ json_response, loading = false }) => {
    const [open, setOpen] = useState<boolean>(true);

    return (
        <div
            className={`h-screen rounded-lg w-full overflow-auto pn_scroller transition-all duration-300 ease-in-out ${open
                ? "flex-[0_0_100%] sm:flex-[0_0_75%] lg:flex-[0_0_460px] max-w-full lg:max-w-[460px]"
                : "flex-[0_0_100%] sm:flex-[0_0_215px] max-w-full sm:max-w-[215px]"
                }`}
        >
            <div className="flex flex-col h-full bg-opacity-50">
                {/* Header */}
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                        <h2 className="text-lg font-semibold">{json_response?.title}</h2>
                    </div>
                    <button
                        onClick={() => setOpen(!open)}
                        className="cursor-pointer rounded border border-[#DFE3E8] p-1 hover:bg-gray-100"
                        aria-label="Toggle Panel"
                    >
                        <img
                            src={SwitchIcon}
                            alt="Toggle"
                            className="w-3 h-3 object-contain"
                        />
                    </button>
                </div>

                {loading ? (
                    <div className="flex-1 flex items-center justify-center text-sm text-gray-500 animate-pulse">
                        <DotLoader />
                    </div>
                ) : (
                    <>
                        <div className="mb-4">
                            <div className="text-sm">{decodeURIComponent(json_response?.summary || "")}</div>
                        </div>

                        <div className="space-y-[12px]">
                            {json_response?.findings?.map((item, index) => (
                                <div
                                    key={index}
                                    className={`flex items-start gap-2 p-2 rounded-md border border-[#D7D7D7] ${item.type === "success" ? "text-[#358500]" : ""
                                        }`}
                                >
                                    <p className="text-sm text-gray-800">  {decodeURIComponent(item.text)}</p>
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default QuickHealth;
